import { useCustomHeaderBorderColor } from "@circle-react-shared/uikit/HeaderV3/useHeaderColors";
import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import type { CSSCustomProperties } from "@circleco/compass/components/MobileShell";

import {
  HEADER_COMPASS_BADGE_THEME_VARS,
  HEADER_COMPASS_THEME_VARS,
  MOBILE_HEADER_BACKGROUND_THEME_VARS,
} from "./headerThemeVars";

/**
 * Mobile equivalent of desktop's `HeaderWrapperRoot` combo - static
 * background/token remap plus `useHeaderBorderStyles()`'s computed border
 * color. `MobileShell.Header` only accepts `themeVars` (CSS custom
 * properties), so the resolved border hex is delivered as a
 * `--color-border-primary`/`-secondary` remap instead, gated by
 * `useIsCustomColorTheme()` (mirrors `useSidebarCompassThemeVars`).
 */
export const useMobileHeaderThemeVars = (): CSSCustomProperties => {
  const isCustomColorTheme = useIsCustomColorTheme();
  const borderColor = useCustomHeaderBorderColor();

  // Default theme opts out of community branding, but keeps the
  // unread-counter tokens so it still matches the sidebar's badge
  if (!isCustomColorTheme) {
    return HEADER_COMPASS_BADGE_THEME_VARS;
  }

  return {
    ...HEADER_COMPASS_THEME_VARS,
    ...MOBILE_HEADER_BACKGROUND_THEME_VARS,
    "--color-border-primary": borderColor,
    "--color-border-secondary": borderColor,
  };
};
